import { observable, makeAutoObservable } from 'mobx';
import { CasinoBannersDataState } from 'src/AppState/CmsState/CasinoBannersDataState/CasinoBannersData.state';

export class DateState {
    constructor(private readonly casinoBannersState: CasinoBannersDataState) {
        makeAutoObservable(this);
    }
    @observable public startDateError = false;
    @observable public endDateError = false;

    public onChangeStartDate = (date: Date | null): void => {
        if (date !== null) {
            this.casinoBannersState.dateStart.setValue(date.toISOString());
        }
    };

    public onBlurStartDate = (date: React.FocusEvent<HTMLInputElement>): void => {
        if (date.target.value === '') {
            this.startDateError = true;
        } else if (this.startDateError) {
            this.startDateError = false;
        }
    };

    public onChangeEndDate = (date: Date | null): void => {
        if (date !== null) {
            this.casinoBannersState.dateEnd.setValue(date.toISOString());
        }
    };

    public onBlurEndDate = (date: React.FocusEvent<HTMLInputElement>): void => {
        if (date.target.value === '') {
            this.endDateError = true;
        } else if (this.endDateError) {
            this.endDateError = false;
        }
    };

    public preventDefault = (e: React.FormEvent<HTMLFormElement>): void => {
        e.preventDefault();
    };
}
